import React from 'react';

const Header = ({ playerCount, roundInfo, gameMode = 'trump-card', onLeave }) => {
  const getPlayerCountDisplay = () => {
    if (gameMode === 'trump-card') {
      return `${playerCount}/4`;
    }
    return `${playerCount}`;
  };

  const handleLeave = () => {
    if (!window.confirm('Leave this game?')) return;
    onLeave();
  };

  return (
    <header>
      <h1>🏏 4Options</h1>
      <div className="game-info">
        <span>Players: {getPlayerCountDisplay()}</span>
        {roundInfo && <span>{roundInfo}</span>}
        {onLeave && (
          <button
            onClick={handleLeave}
            style={{
              background: 'transparent', border: '1px solid currentColor',
              borderRadius: 8, color: 'inherit', padding: '4px 10px',
              cursor: 'pointer', fontSize: 13,
            }}
          >🏠 Leave</button>
        )}
      </div>
    </header>
  );
};

export default Header;